"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var hasOwnPropertyChain = function (properties) {
    var initial = window;
    var checked = properties.map(function (propertyName) {
        if (Object.prototype.hasOwnProperty.call(initial, propertyName)) {
            initial = initial[propertyName];
            return true;
        }
        return false;
    });
    return checked.every(function (element) { return element; });
};
var getValueFromProperty = function (properties) {
    return properties.reduce(function (acc, currentValue) { var _a; return (_a = acc[currentValue]) !== null && _a !== void 0 ? _a : undefined; }, window);
};
var useAsyncGlobalVariable = function (properties) {
    var _a = (0, react_1.useState)(hasOwnPropertyChain(properties)), exist = _a[0], setExist = _a[1];
    var repeat = 0;
    var waitForGlobal = function () {
        if (hasOwnPropertyChain(properties)) {
            setExist(true);
        }
        else if (repeat < 10) {
            setTimeout(waitForGlobal, 250 * repeat);
            repeat += 1;
        }
    };
    if (!exist) {
        waitForGlobal();
    }
    return { exist: exist, value: exist ? getValueFromProperty(properties) : undefined };
};
exports.default = useAsyncGlobalVariable;
